import { motion } from "framer-motion";
import { ShieldCheck, Truck, Eye } from "lucide-react";
import { QuoteForm } from "./QuoteForm";
import { IMAGES } from "../data";

const PERKS = [
  { icon: Eye, text: "Free 3D digital proof before print" },
  { icon: Truck, text: "Door-to-door delivery in 15 days" },
  { icon: ShieldCheck, text: "Food-safe, FSC® certified stock" },
];

export const QuoteSection = ({ presetType }) => (
  <section id="quote" className="relative py-24 sm:py-32 overflow-hidden" data-testid="quote-section">
    <div className="absolute inset-0">
      <img src={IMAGES.singleWall} alt="" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-[#170A38]/90" />
    </div>
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="text-[#FAF7F2]"
      >
        <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-[#FBBF24] mb-4" data-testid="quote-eyebrow">
          Got a project in mind?
        </p>
        <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-tight" data-testid="quote-headline">
          From napkin sketch to{" "}
          <span className="italic text-[#FF5A36]">10,000 hands</span> in 15 days.
        </h2>
        <p className="mt-5 text-[#FAF7F2]/70 leading-relaxed max-w-md">
          Tell us about your brand and we will come back with print pricing,
          a free 3D proof and vendor-placement options in your neighbourhood.
        </p>
        <ul className="mt-8 space-y-4">
          {PERKS.map((p) => (
            <li key={p.text} className="flex items-center gap-3 font-semibold text-[#FAF7F2]/85">
              <span className="w-9 h-9 rounded-full bg-[#FF5A36]/20 flex items-center justify-center shrink-0">
                <p.icon className="w-4.5 h-4.5 w-5 h-5 text-[#FF5A36]" />
              </span>
              {p.text}
            </li>
          ))}
        </ul>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
        className="bg-[#FAF7F2] rounded-[2rem] p-7 sm:p-9 shadow-2xl"
        data-testid="quote-form-card"
      >
        <QuoteForm presetType={presetType} />
      </motion.div>
    </div>
  </section>
);
